import Duck from "redux-ducks-ts"

export const profile = new Duck("ratings", "cargo")
